import { render } from "./gallery-detail.vue?vue&type=template&id=3584eb14"
import script from "./gallery-detail.vue?vue&type=script&lang=js"
export * from "./gallery-detail.vue?vue&type=script&lang=js"

import "./gallery-detail.vue?vue&type=style&index=0&id=3584eb14&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__